import { isCommerceLinkWrapperConfig } from '../typeGuards/index.js';
import skimlinksLinkWrapper from './skimlinksLinkWrapper.js';
import trackonomicsLinkWrapper from './trackonomicsLinkWrapper.js';
export const LinkWrappers = {
    Skimlinks: skimlinksLinkWrapper,
    Trackonomics: trackonomicsLinkWrapper,
};
export function applyLinkWrappers(linkUrl, wrapConfigs, wrapperFns = LinkWrappers) {
    wrapConfigs.forEach((wrapper) => (linkUrl = applyLinkWrapper(linkUrl, wrapper, wrapperFns)));
    return linkUrl;
}
function applyLinkWrapper(linkUrl, config, wrapperFns = LinkWrappers) {
    if (!isCommerceLinkWrapperConfig(config) ||
        wrapperFns[config.vendor] === undefined ||
        config.disabled === true) {
        return linkUrl;
    }
    return wrapperFns[config.vendor](linkUrl, config);
}
//# sourceMappingURL=linkWrapperFunctions.js.map